import { useAuthStore } from '@/client/services/state/authStore';

export const useCheckAccessProfile = () => {
  const { authConfig } = useAuthStore();
  const { user } = authConfig;
  const { access_profile: accessProfile } = user;

  if (
    accessProfile &&
    accessProfile.permissions.admin.users.restricted_access &&
    !accessProfile.permissions.admin.workflows
  ) {
    window.location.replace('/pvt/#/overview/assignments');
  }
};
